module.exports = __webpack_public_path__ + "img/The urban housing crises of Indonesia and Malaysia.36407c63.jpg";